'use strict';

// LP実績バンドのカウントアップ。.lp-count[data-to] を 0→値 でアニメーション。
// easeOutCubic / toLocaleString。prefers-reduced-motion 尊重（最終値を即表示）。
(function() {
  const DURATION = 1100;

  function countUp(el) {
    const to = Number(el.dataset.to) || 0;
    const start = performance.now();

    function tick(now) {
      const p = Math.min((now - start) / DURATION, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.floor(to * eased).toLocaleString();
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function init() {
    const els = document.querySelectorAll('.lp-count');
    if (els.length === 0) return;

    const prefersReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReduce || !('IntersectionObserver' in window)) {
      els.forEach((el) => {
        el.textContent = (Number(el.dataset.to) || 0).toLocaleString();
      });
      return;
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          countUp(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    els.forEach((el) => io.observe(el));
  }

  document.addEventListener('turbolinks:load', init);
})();
